import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { AccountBreadcrumb } from '../../../../../../../../../features/registration/account/account-breadcrumb';

export const Route = createFileRoute('/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding')({
  loader: ({ params }) =>
    ({
      breadcrumb: buildBreadcrumb({
        id: `account-funding-${params.accountId}`,
        label: <AccountBreadcrumb accountId={params.accountId} displayIdOnly />,
        to: `/registration/account/${params.accountId}/funding`,
      }),
    }) satisfies AggregateBreadcrumb,
});
